module.exports = __webpack_public_path__ + "img/no.befbd62d.svg";